import { WifiOff } from 'lucide-react';
import { useOfflineStatus } from '../../hooks/useOfflineStatus';

export function OfflineBadge() {
  const { isOnline, pendingCount } = useOfflineStatus();

  if (isOnline && pendingCount === 0) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium bg-amber-50 text-amber-700 dark:bg-amber-950/60 dark:text-amber-400 shadow-lg border border-amber-200 dark:border-amber-800">
      {!isOnline && <WifiOff size={18} />}
      {!isOnline && <span>Offline</span>}
      {pendingCount > 0 && (
        <span className="inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 text-xs font-bold text-white bg-amber-500 rounded-full">
          {pendingCount}
        </span>
      )}
    </div>
  );
}
